module.exports = __webpack_public_path__ + "ea17e7c50966f23e40b9c3b0f2546d65.svg";